import { render } from "./AreaLogin.vue?vue&type=template&id=d3f67aa2&scoped=true"
import script from "./AreaLogin.vue?vue&type=script&lang=js"
export * from "./AreaLogin.vue?vue&type=script&lang=js"

import "./AreaLogin.vue?vue&type=style&index=0&id=d3f67aa2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f67aa2"]])

export default __exports__